import { Stack, Typography } from "@mui/material";
import { FunctionComponent, useState } from "react";
import { useTranslation } from "react-i18next";
import { TimeSheet, TimeSheetDay } from "../types/timesheet";
import DayBox from "./DayBox";

interface Props {
  days: TimeSheetDay[];
  variant: "small" | "large";
  onChange?: (day: TimeSheetDay, index: number) => void;
  timesheet: TimeSheet;
  isDialogOpen?: boolean;
}

const Timesheet: FunctionComponent<Props> = (props: Props): JSX.Element => {
  const { days, variant, onChange, timesheet, isDialogOpen } = props;
  const { t } = useTranslation();
  const shortWeekDays = [t("weekdays.mon"), t("weekdays.tue"), t("weekdays.wed"), t("weekdays.thu"), t("weekdays.fri"), t("weekdays.sat"), t("weekdays.sun")];
  const longWeekDays = [
    t("weekdays.monday"),
    t("weekdays.tuesday"),
    t("weekdays.wednesday"),
    t("weekdays.thursday"),
    t("weekdays.friday"),
    t("weekdays.saturday"),
    t("weekdays.sunday"),
  ];
  const [isSmall] = useState<Boolean>(variant === "small" ? true : false);
  const [spacing] = useState<number>(variant === "small" ? 2 : 4);

  return (
    <>
      <Stack direction={"row"} padding={0} spacing={spacing}>
        {isSmall
          ? shortWeekDays.map((day, index) => (
            <Typography
              key={index}
              variant="caption"
              sx={{ width: "30px", textAlign: "center" }}
            >
              {" "}
              {day}{" "}
            </Typography>
          ))
          : longWeekDays.map((day, index) => (
            <Typography
              key={index}
              variant="caption"
              sx={{ width: "50px", textAlign: "center" }}
            >
              {" "}
              {day}{" "}
            </Typography>
          ))}
      </Stack>

      <Stack direction={"row"} padding={0} spacing={spacing}>
        {timesheet.status === 3 ? (
          timesheet.amendedDays.map((day, index) => (
            <DayBox
              key={index}
              variant={variant}
              day={day}
              index={index}
              timesheet={timesheet}
              onChange={(day, index) => {
                if (onChange) {
                  onChange(day, index);
                }
              }}
            />
          ))
        ) : (
          days.map((day, index) => (
            <DayBox
              key={index}
              variant={variant}
              day={day}
              index={index}
              timesheet={timesheet}
              isDialogOpen={isDialogOpen}
              onChange={(day, index) => {
                if (onChange) {
                  onChange(day, index);
                }
              }}
            />
          ))
        )}
      </Stack>

    </>
  );
};

export default Timesheet;
